<template>
  <v-container fluid>
    <v-dialog v-model="dialog" persistent width="800px">
      <template v-slot:activator="{ on }">
       <v-btn primary v-on="on">Add</v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Add Parcel Number Range</span>
        </v-card-title>
        <v-card-text>
          <v-alert>{{addParcelNumberRangeError}}</v-alert>

          <v-form ref="form" lazy-validation>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-select v-model="pnr_type" :items="types" filled label="Type" />
                </v-flex>
                <v-flex xs12 sm5>
                  <v-text-field
                    label="Start Number"
                    required
                    v-bind:counter="getType(pnr_type).min"
                    :rules="[validateRequired('pnr_startNumber'), validateLength('pnr_startNumber', getType(pnr_type).min)]"
                    v-model="pnr_startNumber"
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm5>
                  <v-text-field
                    label="End Number"
                    required
                    v-bind:counter="getType(pnr_type).min"
                    :rules="[validateRequired('pnr_endNumber'), validateLength('pnr_endNumber', getType(pnr_type).min)]"
                    v-model="pnr_endNumber"
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field label="Depot" v-model="pnr_depo" type="number"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field label="Service" v-model="pnr_service" type="text"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    hint
                    label="Parcel Number Container Id"
                    disabled
                    v-model="pnr_parcelnumberContainerId"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn primary @click.native="addParcelNumberRange()">Save</v-btn>
          <v-btn primary @click.native="formReset()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card>
      <v-data-table
        class="elevation-1"
        :headers="headers"
        :items="items"
        :options.sync="pagination"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="footerProps"
        @update:items-per-page="getItemPerPage"
      >
        <template class="text-xs-left" v-slot:item="{ item }">
         <tr>
          <td class="text-xs-left">{{ item.id }}</td>
          <td class="text-xs-left">{{ item.startNumber }}</td>
          <td class="text-xs-left">{{ item.endNumber }}</td>
          <td class="text-xs-left">{{ item.state }}</td>
          <td class="text-xs-left">{{ item.service }}</td>
          <td class="text-xs-left">{{ item.size }}</td>
          <td class="text-xs-left">{{ item.size - item.consumed + item.reserved }}</td>
        </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>


<script>
import DataService from '../services/data'

export default {
  data() {
    return {
      pnr_type: 'DEFAULT',
      pnr_startNumber: undefined,
      pnr_endNumber: undefined,
      pnr_depo: undefined,
      pnr_service: undefined,
      pnr_parcelnumberContainerId: this.$route.params.id,
      dialog: false,
      dataService: undefined,

      rules: {
        required: value => !!value || 'Required.'
      },
      items: [],
      addParcelNumberRangeError: '',
      pagination: { rowsPerPage: 10 },
      footerProps: {
        showFirstLastPage: true,
        firstIcon: 'mdi-chevron-double-left',
        lastIcon: 'mdi-chevron-double-right',
        prevIcon: 'mdi-chevron-left',
        nextIcon: 'mdi-chevron-right',
        itemsPerPageOptions: [10,20,40]
      },
      loading: true,
      totalItems: 0,
      headers: [
        { text: 'ID', value: 'id', sortable: false },
        { text: 'START NUMBER', value: 'startNumber', sortable: false },
        { text: 'END NUMBER', value: 'endNumber', sortable: false },
        { text: 'STATE', value: 'state', sortable: false },
        { text: 'SERVICE', value: 'service', sortable: false },
        { text: 'SIZE', value: 'size', sortable: false },
        { text: 'AVAILABLE', value: 'available', sortable: false }
      ],
      types: [
        { text: 'default', value: 'DEFAULT', min: 11, max: 11 },
        { text: 'GB', value: 'GB', min: 8, max: 8 },
        { text: 'ID_COLLO', value: 'ID_COLLO', min: 15, max: 15 },
        { text: 'FR', value: 'FR', min: 8, max: 8 },
        { text: 'NL_INBOUND', value: 'NL_INBOUND', min: 10, max: 10 }
      ]
    }
  },

  watch: {
    pagination() {
      this.queryPagination().then(this.updateDataTable)
    }
  },

  created() {
    console.info('show parcel number range')
    this.dataService = new DataService(this.profile, this.$store.state.tokens)
    this.queryPagination().then(this.updateDataTable)
  },

  computed: {
    payload() {
      return {
        startNumber: this.pnr_startNumber,
        endNumber: this.pnr_endNumber,
        depo: this.pnr_depo,
        service: this.pnr_service,
        parcelnumberContainerId: this.$route.params.id,
        type: this.pnr_type
      }
    }
  },

  methods: {

    getItemPerPage(rows) {
      this.pagination.rowsPerPage = rows;
      this.queryPagination()
    },
    queryPagination() {
      let { sortBy, descending, page, rowsPerPage } = this.pagination
/*       if (descending) {
        sortBy = `${sortBy},desc`
      }
      if (!sortBy) {
        sortBy = `Id`
      } */
      if (this.dataService) {
        this.loading = true
        return this.dataService.getParcelNumberRangesByContainerId(
          this.$route.params.id,
          page,
          rowsPerPage,
          sortBy
        )
      }
      return Promise.reject('dataservice not ready')
    },
    updateDataTable(result) {
      this.loading = false
      this.items = result.data.content
      this.totalItems = result.data.totalElements
      return result
    },
    formReset() {
      this.pnr_startNumber = undefined
      this.pnr_endNumber = undefined
      this.pnr_depo = undefined
      this.pnr_service = undefined
      this.addParcelNumberRangeError = undefined
      this.dialog = false
    },

    addParcelNumberRange() {
      if (!this.$refs.form.validate()) {
        console.error('invalid formular values')
        return false
      }

      this.dataService
        .addParcelNumberRange(this.payload)
        .then(result => {
          console.info('add ParcelNumberRange -> result', result.data)
          this.queryPagination().then(this.updateDataTable)
          this.formReset()
        })
        .catch(err => {
          if (err.response) {
            console.error('Error : ', err.response.data.message)
            this.addParcelNumberRangeError = err.response.data.message
            this.addParcelNumberRangeError = this.addParcelNumberRangeError.replace(
              '\n',
              '</br>'
            )
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('Error', err.message)
          }
        })
    },

    validateRequired(fieldName) {
      return (
        (this[fieldName] && this[fieldName].length > 0) ||
        'This field is required'
      )
    },

    validateMax(fieldName, max) {
      return (
        (this[fieldName] && this[fieldName].length <= max) ||
        `This field has a max length of ${max} characters`
      )
    },

    validateMin(fieldName, min) {
      return (
        (this[fieldName] && this[fieldName].length >= min) ||
        `This field has a min length of ${min} characters`
      )
    },

    validateLength(fieldName, min) {
      return (
        (this[fieldName] && this[fieldName].length === min) ||
        `This field has an exact length of ${min} characters`
      )
    },

    getType(typeValue) {
      return this.types.find(type => type.value === typeValue) || this.types[0]
    }
  }
}
</script>



// WEBPACK FOOTER //
// GetParcelNumberRange.vue?fa5fb26c